export default __webpack_public_path__ + "static/media/csv.5bd8e8fd.svg";